import { render } from "./SideBarSmall.vue?vue&type=template&id=0ca8d865&scoped=true"
import script from "./SideBarSmall.vue?vue&type=script&lang=js"
export * from "./SideBarSmall.vue?vue&type=script&lang=js"

import "./SideBarSmall.vue?vue&type=style&index=0&id=0ca8d865&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca8d865"]])

export default __exports__